import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum ComplianceRuleVersionType {
  MinAge = 'ComplianceRuleVersion::MinAge',
  CubanId = 'ComplianceRuleVersion::CubanId',
}

export interface ComplianceRuleAttributes {
  status: 'active' | 'inactive';
  'version-type': ComplianceRuleVersionType;
}

export type ComplianceRule = ApiResource<ComplianceRuleAttributes, ApiModel.ComplianceRule>;
